import { ReactNode } from 'react';
import { PopoverOptions, usePopover } from './usePopover';
import { PopoverContext } from './context';
import { PopoverTrigger } from './PopoverTrigger';
import { PopoverContent } from './PopoverContent';
import './Popover.scss';

/**
 * Example usage:
 * ```
 * <Popover>
 *     <Popover.Trigger>
 *         <button>Click me</button>
 *     </Popover.Trigger>
 *     <Popover.Content>
 *         I'll only show up when the button is clicked
 *      </Popover.Content>
 * </Popover>
 * ```
 * Note: If the child of `<Popover.Trigger>` is a React component it will need a forwardRef
 */
function Popover({ children, ...popoverOptions }: { children: ReactNode } & PopoverOptions) {
    const popoverContext = usePopover(popoverOptions);
    return <PopoverContext.Provider value={popoverContext}>{children}</PopoverContext.Provider>;
}

Popover.Trigger = PopoverTrigger;
Popover.Content = PopoverContent;

export { Popover };
